module.exports = new __parcel__URL__("welcome-illustration.5af9c8d1.png").toString();